module.exports = __webpack_public_path__ + "media/images/athletes/2364-8765603f8b285ba3e9664b26b8af3001.png";